import React, { useContext } from 'react'

import styled from 'styled-components'
import Slider from 'react-slick'
import '../ui/sliderStyles.css'

import { useI18n, LocaleContext } from '../../../locale.js'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import ContainerLayout from '../ui/containerLayout'

import checkedCubesCloud from '../../assets/images/elements/checkedCubesCloud.png'
import googleIcon from '../../assets/icons/googleIcon.svg'
import starIcon from '../../assets/icons/starIcon.svg'
import { I18nextContext } from 'gatsby-plugin-react-i18next'
// import facebookIcon from '../../assets/icons/facebookIcon.svg'

// import arrowIcon from '../../assets/icons/arrowRightGreen.svg'
// function SampleNextArrow({ onClick }) {
//   return <ArrowStyled onClick={onClick} variant='outlined' />
// }
// function SamplePrevArrow({ onClick }) {
//   return <ArrowStyled onClick={onClick} variant='outlined' left />
// }

const reviews = [
  {
    name: {
      ru: 'Виктория',
      ua: 'Вікторія',
      en: 'Victoria'
    },
    text: {
      ru: 'Просто кайф! Была здесь дважды с подругой, а потом и папу привела. Постреляли из лука, потом из огнестрельного оружия... Час пролетает незаметно! Очень приветливый администратор всегда поможет и подскажет. Сюда хочется возвращаться!',
      ua: 'Просто кайф! Була тут двічі, з подругою, а потім і тата привела. Постріляли з лука, потім з вогнепальної зброї... Година пролітає непомітно! Дуже привітний адміністратор завжди допоможе і підкаже. Сюди хочеться повертатися!',
      en: 'Too good! Been here twice with a friend and then with Dad. Shooted from a bow, then from a firearm ... The hour flies by unnoticed! A very friendly administrator will always help and prompt. I want to come back here!'
    },
    rating: 5,
    image: '1.jpg'
  },
  {
    name: {
      ru: 'Андрей',
      ua: 'Андрій',
      en: 'Andrew'
    },
    text: {
      ru: 'Были в первый раз. Прекрасный способ весело провести время! Мы так праздновали годовщину свадьбы и это было невероятно! Лучше обычных посиделок в ресторане) Спасибо за безумные эмоции❤',
      ua: 'Були вперше. Чудовий спосіб весело провести час! Ми так святкували річницю весілля і це була неймовірно! Краще звичайних посиденьок в ресторані) Дякуємо за шалені емоції❤',
      en: 'It Was our first time in VR. A great way to have fun! We celebrated our wedding anniversary so much and it was amazing! Better than the usual gatherings in the restaurant) Thank you for the crazy emotions❤'
    },
    rating: 5,
    image: '2.jpg'
  },
  {
    name: {
      ru: 'Диана',
      ua: 'Діана',
      en: 'Diana'
    },
    text: {
      ru: 'Невероятно круто и атмосферно - полное погружение в другую реальность) Так же вежливый и мега позитивный админ) Игра дарит настроение и эмоции! Обязательно придем к вам еще!',
      ua: "Надзвичайно круто, і атмосферно - повне зануреня в іншу реальність)  Також вічливий і мега-позитивний адмін) гра дарує настрій і емоції) Обов'язок прийдемо ще до Вас!",
      en: 'Extremely cool, and atmospheric - full immersion in another reality) Also polite and mega-positive admin) the game gives the mood and emotions) Definitely will come to you again!'
    },
    rating: 5,
    image: '3.jpg'
  },
  {
    name: {
      ru: 'Данил',
      ua: 'Данило',
      en: 'Danil'
    },
    text: {
      ru: 'Хорошее место для отдыха с друзьями, можно играть вчетвером! Всё оформлено в приятном тёмном стиле, доступно много игр, среди которых Half-life Alyx, Pavlov, Serious Sam, Beat Saber, Phasmophobia и ещё много чего. В это место хочется возвращаться!',
      ua: 'Хороше місце для відпочинку з друзями, можна грати учотирьох! Все оформлено в приємному темному стилі, є багато ігор, серед яких Half-life Alyx, Pavlov, Serious Sam, Beat Saber, Phasmophobia і ще багато чого. У це місце хочеться повертатись!',
      en: 'A good place to relax with friends, four players can play together! Everything is decorated in a nice dark style, there are many games available, including Half-life Alyx, Pavlov, Serious Sam, Beat Saber, Phasmophobia and much more. I would like to return to this place!'
    },
    rating: 4.9,
    image: '4.jpg'
  }
]

const Reviews = () => {
  const { locale } = useContext(LocaleContext)
  const context = React.useContext(I18nextContext);
  const breakpoints = useBreakpoint()

  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    lazyLoad: true,
    focusOnSelect: true,
    arrows: false,
    customPaging: function (i) {
      return <span />
    },
    // adaptiveHeight: true,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '0px',
          centerMode: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          centerPadding: '0px',
          centerMode: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '80px',
          centerMode: true
        }
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          centerPadding: '40px',
          centerMode: true
        }
      }
    ]
  }

  const ratingText = useI18n('main.reviews.rating')
  const outOfText = useI18n('main.reviews.outOf')
  const goToReviewText = useI18n('main.reviews.goToReview')
  const showGoogle = false
  return (
    <ContainerLayoutStyled id='reviews'>
      <TitleStyled>
        {useI18n('main.reviews.title')}
        <b>
          &nbsp;
          {useI18n('main.reviews.real')}
          &nbsp;
          <br />
        </b>
        {useI18n('main.reviews.people')}
      </TitleStyled>

      {showGoogle && breakpoints.small ? null : (
        <GeneralRatingSpaceStyled>
          <RationgIconStyled src={googleIcon} alt='Google' />
          <GaneralRatingBlockStyled>
            <RatingStyled>
              <StarIconStyled src={starIcon} alt='' />
              <StarIconStyled src={starIcon} alt='' />
              <StarIconStyled src={starIcon} alt='' />
              <StarIconStyled src={starIcon} alt='' />
              <StarIconStyled src={starIcon} alt='' />
            </RatingStyled>
            <RatingTextStyled>
              {ratingText} 4.9 {outOfText} 5
            </RatingTextStyled>
          </GaneralRatingBlockStyled>
        </GeneralRatingSpaceStyled>
      )}

      <Slider {...settings}>
        {reviews.map((review, i) => (
          <ReviewStyled key={i}>
            <ReviewBlockStyled>
              <ReviewColumnStyled>
                <AvatarStyled
                  src={
                    require('../../assets/images/reviews/' + review.image)
                      .default
                  }
                  alt='Avatar'
                />
                {showGoogle && (
                  <GeneralRatingStyled>
                    <RationgIconStyled src={googleIcon} alt='Google' />
                    <GaneralRatingBlockStyled>
                      <RatingStyled>
                        <StarIconStyled src={starIcon} alt='' />
                        <StarIconStyled src={starIcon} alt='' />
                        <StarIconStyled src={starIcon} alt='' />
                        <StarIconStyled src={starIcon} alt='' />
                        <StarIconStyled src={starIcon} alt='' />
                      </RatingStyled>
                      <RatingTextStyled>
                        {ratingText} {review.rating} {outOfText} 5
                      </RatingTextStyled>
                    </GaneralRatingBlockStyled>
                  </GeneralRatingStyled>
                )}
              </ReviewColumnStyled>
              <UserBlockStyled>
                <UserNameStyled>{context.language && review.name[context.language]}</UserNameStyled>
                <UserReviewTextStyled>
                  {context.language && review.text[context.language]}
                </UserReviewTextStyled>
              </UserBlockStyled>
            </ReviewBlockStyled>
            {/* <LinkStyled>{goToReviewText}</LinkStyled> */}
          </ReviewStyled>
        ))}
      </Slider>
    </ContainerLayoutStyled>
  )
}
export default Reviews

const ContainerLayoutStyled = styled(ContainerLayout)`
  position: relative;

  max-width: 1600px;
  &:after {
    content: '';
    width: 250px;
    height: 380px;

    position: absolute;
    top: 0;
    left: -40%;

    background-image: url(${checkedCubesCloud});
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: left top;
  }
  @media ${(props) => props.theme.breakpoints.small} {
    &:after {
      content: unset;
    }
  }
  .slick-slide {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 20px;
  }

  .slick-dots {
    display: flex !important;
    align-items: center;
    justify-content: center;

    width: 100%;
    margin: 0;

    bottom: -60px;

    list-style: none;
    text-align: center;
    z-index: 1;
  }
  .slick-dots li {
    display: flex;

    margin: 0 5px;
    padding: 0;

    position: relative;
    cursor: pointer;
  }
  .slick-dots li span {
    height: 25px;
    width: 5px;

    background-color: rgba(255, 255, 255, 0.2);
  }
  .slick-dots li.slick-active span,
  .slick-dots li:hover span {
    background-color: ${(props) => props.theme.colors.green};
    transition: 0.3s ease-in-out;
  }

  @media ${(props) => props.theme.breakpoints.laptop} {
    .slick-list {
      margin: 0;
    }
  }
  @media ${(props) => props.theme.breakpoints.large} {
    padding-left: 0;
    padding-right: 0;
    .slick-slide {
      margin: 0 10px;
    }
  }
  @media ${(props) => props.theme.breakpoints.tablet} {
    &:after {
      display: none;
    }
    &:before {
      top: 20px;
      left: 10%;

      background-size: 80%;
    }
    .slick-dots {
      bottom: -50px;
    }
  }
`
const TitleStyled = styled.p`
  margin-bottom: 0.5rem;

  font-size: 2.5rem;
  line-height: 1.14;
  text-align: center;
  color: ${(props) => props.theme.colors.white};

  b {
    color: ${(props) => props.theme.colors.green};
  }
  br {
    display: none;
  }
  @media ${(props) => props.theme.breakpoints.small} {
    margin-bottom: 2.5rem;

    font-size: 1.7rem;
    br {
      display: block;
    }
  }
`
const ReviewStyled = styled.div`
  display: flex !important;
  align-items: center;
  flex-direction: column;

  padding: 40px;
  gap: 30px;

  background-color: #171717;
  border-radius: 5px;
  @media ${(props) => props.theme.breakpoints.small} {
    padding: 25px;
  }
`
const ReviewBlockStyled = styled.div`
  display: flex;

  gap: 30px;
  @media ${(props) => props.theme.breakpoints.tablet} {
    flex-direction: column;

    gap: 20px;
  }
`
const ReviewColumnStyled = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;
  @media ${(props) => props.theme.breakpoints.tablet} {
    align-items: center;
  }
`
const UserBlockStyled = styled(ReviewColumnStyled)`
  gap: 10px;
  @media ${(props) => props.theme.breakpoints.small} {
    gap: 20px;
  }
`

const GeneralRatingStyled = styled.div`
  display: flex;

  gap: 15px;
  @media ${(props) => props.theme.breakpoints.small} {
    gap: 10px;
  }
`
const GeneralRatingSpaceStyled = styled(GeneralRatingStyled)`
  margin: 50px 0;
`
const RationgIconStyled = styled.img`
  width: 40px;
  height: 40px;
  @media ${(props) => props.theme.breakpoints.small} {
    max-width: 30px;
    max-height: 30px;
  }
`
const GaneralRatingBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
`
const RatingStyled = styled.div`
  display: flex;

  gap: 2px;
`
const StarIconStyled = styled.img`
  width: 20px;
  height: 20px;
  @media ${(props) => props.theme.breakpoints.small} {
    width: 15px;
    height: 15px;
  }
`
const RatingTextStyled = styled.p`
  color: ${(props) => props.theme.colors.grey};
  font-size: 0.95rem;
  @media ${(props) => props.theme.breakpoints.small} {
    font-size: 0.8rem;
  }
`
const AvatarStyled = styled.img`
  max-width: 180px;
  min-width: 140px;
  min-height: 140px;
  object-fit: cover;
  aspect-ratio: 3 / 4;
  @media ${(props) => props.theme.breakpoints.small} {
    max-width: 90px;
    max-height: 90px;
  }
`
const UserNameStyled = styled.p`
  color: ${(props) => props.theme.colors.white};
  font-size: 1.1rem;
  font-family: ${(props) => props.theme.fonts.futuraDemi};
`

const UserReviewTextStyled = styled(UserNameStyled)`
  font-family: ${(props) => props.theme.fonts.futura};
  line-height: 1.1;

  @media ${(props) => props.theme.breakpoints.tablet} {
    text-align: center;
  }
`

const LinkStyled = styled.a`
  color: ${(props) => props.theme.colors.green};
  font-size: 0.95rem;
  font-family: ${(props) => props.theme.fonts.futuraDemi};
  text-decoration: underline;
  white-space: nowrap;

  cursor: pointer;

  @media ${(props) => props.theme.breakpoints.small} {
    font-size: 1rem;
  }
`

// const ArrowStyled = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   width: 32px;
//   height: 32px;

//   padding: 0;

//   position: absolute;
//   right: -60px;
//   top: 60%;
//   z-index: 1;

//   background-color: transparent;
//   background-image: url(${arrowIcon});
//   background-size: 50%;
//   background-position: center;
//   background-repeat: no-repeat;

//   border: 1px solid ${(props) => props.theme.colors.green};
//   cursor: pointer;

//   ${(props) =>
//     props.left &&
//     `transform: scale(-1,1);
//     left: -60px;
//     right: 0px;
//   `};

//   &:before {
//     content: '';
//     width: 100%;
//     height: calc(100% + 2px);
//     position: absolute;
//     left: -1.5px;
//     background: linear-gradient(90deg, #030303, 15%, transparent);
//   }
//   &:hover:before {
//     content: unset;
//   }
// `
